import { Box, CircularProgress } from '@mui/material';
import { PAGE_HEIGHT } from '../constants';

type IProps = {
  height?: string;
};

export const LoadingSpinner = ({ height = PAGE_HEIGHT }: IProps) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      height={height}
    >
      <CircularProgress />
    </Box>
  );
};
